import React, { useState } from 'react';
import ReusableSidebar from '../../components/sidebar/reusable-sidebar';
import { useUser } from '../../services/contexts/user-context';
import { MainContent } from '../../components/sidebar/sidebar.styles';
import ChooseTemplate from '../choose-template/choose-template';
import Loading from '../../components/loading';

const DefaultTemplates = () => {
  const { user, isLoading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        selectedPage="templates"
        user={user}
        loading={isLoading}
      />

      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? <Loading /> : <ChooseTemplate />}
      </MainContent>
    </>
  );
};

export default DefaultTemplates;















